import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

export const ctfChallengePageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": {
    ctf: {
      pages: {
        challenges: {
          title: "赛题库",
          subtitle: "创建赛题和草稿版本，绑定制品并发布静态附件题。",
          createAction: "新建赛题",
          createTitle: "新建赛题",
          createSuccess: "赛题已创建",
          createVersionAction: "创建版本",
          createVersionTitle: "创建草稿版本",
          createVersionSuccess: "草稿版本已创建，版本号：{id}",
          pickCategoryAction: "查找带回分类",
          pickArtifactAction: "查找带回制品",
          bindArtifactAction: "绑定制品",
          bindArtifactTitle: "绑定制品发布物",
          bindArtifactSuccess: "制品已绑定",
          publishAction: "发布版本",
          publishTitle: "发布赛题版本",
          publishSuccess: "版本已发布",
          loadFailed: "加载赛题失败",
          activeCategoryRequired: "请先创建可用的赛题分类",
          readyArtifactRequired: "请先登记 ready 状态的制品发布物",
          versionIdHelp: "创建草稿版本后，可使用返回的版本号继续完成制品绑定和发布。"
        }
      }
    }
  },
  en: {
    ctf: {
      pages: {
        challenges: {
          title: "Challenges",
          subtitle: "Create challenges and draft versions, then bind artifacts and publish static attachment challenges.",
          createAction: "Create challenge",
          createTitle: "Create challenge",
          createSuccess: "Challenge created",
          createVersionAction: "Create version",
          createVersionTitle: "Create draft version",
          createVersionSuccess: "Draft version created, version No.: {id}",
          pickCategoryAction: "Find and pick category",
          pickArtifactAction: "Find and pick artifact",
          bindArtifactAction: "Bind artifact",
          bindArtifactTitle: "Bind artifact release",
          bindArtifactSuccess: "Artifact bound",
          publishAction: "Publish version",
          publishTitle: "Publish challenge version",
          publishSuccess: "Version published",
          loadFailed: "Failed to load challenges",
          activeCategoryRequired: "Create an active category first",
          readyArtifactRequired: "Register a ready artifact release first",
          versionIdHelp: "After creating a draft version, use the returned version No. to continue artifact binding and publishing."
        }
      }
    }
  },
  ja: {
    ctf: {
      pages: {
        challenges: {
          title: "問題",
          subtitle: "問題と草稿バージョンを作成し、成果物を紐付けて静的添付問題を公開します。",
          createAction: "問題作成",
          createTitle: "問題作成",
          createSuccess: "問題を作成しました",
          createVersionAction: "バージョン作成",
          createVersionTitle: "草稿バージョン作成",
          createVersionSuccess: "草稿バージョンを作成しました。バージョン番号：{id}",
          pickCategoryAction: "カテゴリを検索して反映",
          pickArtifactAction: "成果物を検索して反映",
          bindArtifactAction: "成果物紐付け",
          bindArtifactTitle: "成果物を紐付け",
          bindArtifactSuccess: "成果物を紐付けました",
          publishAction: "公開",
          publishTitle: "問題バージョン公開",
          publishSuccess: "バージョンを公開しました",
          loadFailed: "問題の読み込みに失敗しました",
          activeCategoryRequired: "先に有効なカテゴリを作成してください",
          readyArtifactRequired: "先に ready 状態の成果物を登録してください",
          versionIdHelp: "草稿バージョンを作成した後、返却されたバージョン番号で成果物の紐付けと公開を続行します。"
        }
      }
    }
  }
};
